// ─────────────────────────────────────────────────────────────
// StatsCard — compact variant of KpiCard for in-page stat strips
//   ┌──────────────────────┐
//   │ LABEL (mono, dim)    │
//   │ 14                   │  ← Fraunces 32px
//   │ Companies in portal  │  ← sub copy
//   └──────────────────────┘
// No sparkline / delta — keeps the strip dense and legible.
// ─────────────────────────────────────────────────────────────

interface StatsCardProps {
  label: string;
  value: number | string;
  sub?: string;
  accent?: string;
  loading?: boolean;
}

export function StatsCard({ label, value, sub, accent, loading = false }: StatsCardProps) {
  return (
    <div
      style={{
        background: 'var(--color-panel)',
        border: '1px solid var(--color-border)',
        borderRadius: 10,
        padding: '16px 20px 14px',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {accent && (
        <span
          aria-hidden
          style={{
            position: 'absolute',
            left: 0,
            top: 12,
            bottom: 12,
            width: 3,
            borderRadius: 2,
            background: accent,
            opacity: 0.85,
          }}
        />
      )}
      <div
        style={{
          fontSize: 10.5,
          color: 'var(--color-text-dim)',
          letterSpacing: 1.2,
          textTransform: 'uppercase',
          fontWeight: 500,
          fontFamily: 'var(--font-mono)',
        }}
      >
        {label}
      </div>
      {loading ? (
        <div
          className="animate-pulse"
          style={{ width: 60, height: 30, borderRadius: 4, background: 'var(--color-border)', marginTop: 6 }}
        />
      ) : (
        <div
          style={{
            fontFamily: 'var(--font-display)',
            fontSize: 32,
            fontWeight: 500,
            letterSpacing: -0.8,
            color: 'var(--color-text)',
            marginTop: 4,
            lineHeight: 1,
          }}
        >
          {value}
        </div>
      )}
      {sub && (
        <div style={{ fontSize: 12, color: 'var(--color-text-mid)', marginTop: 6 }}>{sub}</div>
      )}
    </div>
  );
}
